import { Action } from '@ngrx/store';

export enum UserSubscribedListsActionTypes {
  FETCH_LIST_SUBSCRIPTION = '[User Subscribed Lists] Fetch List Subscription',
  FETCH_LIST_SUBSCRIPTION_SUCCESS = '[User Subscribed Lists] Fetch List Subscription Success',
  FETCH_LIST_SUBSCRIPTION_FAILED = '[User Subscribed Lists] Fetch List Subscription Failed',
  UPDATE_LIST_SUBSCRIPTION = '[User Subscribed Lists] Update List Subscription',
  UPDATE_LIST_SUBSCRIPTION_SUCCESS = '[User Subscribed Lists] Update List Subscription Success',
  UPDATE_LIST_SUBSCRIPTION_FAILED = '[User Subscribed Lists] Update List Subscription Failed',
}

export interface UserAndListPayload {
  userId: string;
  listId: string;
}

export class FetchListSubscriptionAction implements Action {
  readonly type = UserSubscribedListsActionTypes.FETCH_LIST_SUBSCRIPTION;

  constructor(public payload: UserAndListPayload) {}
}

export interface ListSubscriptionPayload {
  listId: string;
  isSubscribed: boolean;
}

export class FetchListSubscriptionSuccessAction implements Action {
  readonly type =
    UserSubscribedListsActionTypes.FETCH_LIST_SUBSCRIPTION_SUCCESS;

  constructor(public payload: ListSubscriptionPayload) {}
}

export interface ErrorAndListPayload {
  listId: string;
  error: any;
}

export class FetchListSubscriptionFailedAction implements Action {
  readonly type = UserSubscribedListsActionTypes.FETCH_LIST_SUBSCRIPTION_FAILED;

  constructor(public payload: ErrorAndListPayload) {}
}

export class UpdateListSubscriptionAction implements Action {
  readonly type = UserSubscribedListsActionTypes.UPDATE_LIST_SUBSCRIPTION;

  constructor(public payload: UserAndListPayload) {}
}

export class UpdateListSubscriptionSuccessAction implements Action {
  readonly type =
    UserSubscribedListsActionTypes.UPDATE_LIST_SUBSCRIPTION_SUCCESS;

  constructor(public payload: ListSubscriptionPayload) {}
}

export class UpdateListSubscriptionFailedAction implements Action {
  readonly type =
    UserSubscribedListsActionTypes.UPDATE_LIST_SUBSCRIPTION_FAILED;

  constructor(public payload: ErrorAndListPayload) {}
}

export type UserSubscribedListsActions =
  | FetchListSubscriptionAction
  | FetchListSubscriptionSuccessAction
  | FetchListSubscriptionFailedAction
  | UpdateListSubscriptionAction
  | UpdateListSubscriptionSuccessAction
  | UpdateListSubscriptionFailedAction;
